module.exports = __webpack_public_path__ + "img/chemcatbio-logo-reverse-02.b2df916a.png";